module.exports = __webpack_public_path__ + "img/puntxat.b92642c3.png";